export const { setTimeout } = window
